import {lineMidpoint} from "geometric";

export default class Utils
{
    static distance (pt1, pt2)
    {
        let diffX = pt1.x - pt2.x;
        let diffY = pt1.y - pt2.y;

        return Math.sqrt( (diffX * diffX) + (diffY * diffY) );
    }


    static getPtFromAngle (angle, radius)
    {
        let rAngle = Math.PI / 180 * angle;
        let x = Math.sin(rAngle) * radius;
        let y = Math.cos(rAngle) * radius;

        return {x, y}
    }


    static getCenterFromRect (rect)
    {
        // let x = rect.x + rect.width / 2;
        // let y = rect.y + rect.height / 2;
        //
        // return {x,y};

        return this.getPointFromRect(rect, {x:0.5, y:0.5})
    }



    static getPointFromRect (rect, gravity)
    {
        let x = rect.x + rect.width * gravity.x;
        let y = rect.y + rect.height * gravity.y;

        return {x,y};
    }

    static getLineMidpoint (pt1, pt2)
    {

        let l = [[pt1.x, pt1.y],[pt2.x, pt2.y] ]

        let ptMidpoint = lineMidpoint(l);

        return {x:ptMidpoint[0], y: ptMidpoint[1]};
    }
}